const CardUtil = {
    sameColor(card1: number | string, card2: number | string) {
        return parseInt(card1.toString()) % 10 === parseInt(card2.toString()) % 10;
    },
};
export default CardUtil;
